import type { AttachmentFile, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useRequest } from "../../utils/request";
import { bondRequestAttachmentsQueryKey } from "../bond-request/bond-request.keys";

export const useFetchQuoteAttachments = (accountId: SuretyAccountId, quoteId: SuretyQuoteId) => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();

	const isAdmin = user.type === "admin";

	const { data, error, isLoading } = useQuery({
		queryKey: bondRequestAttachmentsQueryKey(quoteId),
		queryFn: async () => {
			const url = isAdmin
				? `/v2/admin/surety/accounts/${accountId}/quotes/${quoteId}/attachments`
				: `/v2/surety/accounts/${accountId}/quotes/${quoteId}/attachments`;
			return await get<AttachmentFile[]>(url);
		},
	});

	const attachments = useMemo(() => data ?? [], [data]);

	return {
		attachments,
		attachmentsError: error,
		attachmentsIsLoading: isLoading,
	};
};
